// @LTG-ID: scroll-to-top
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 08_FEATURES.md, ORCH-0050 reinforcement (P3 plumbing primitive)
// @CHANGED: 2026-02 session_004 (CHG-0056)
// @OWNER: web
//
// ScrollToTop — React Router navigation utility. Mounts inside SiteLayout once;
// listens to `location.pathname` changes and scrolls window to (0, 0) on route
// transition. Renders nothing.
//
// Why: React Router DOES NOT scroll to top automatically on route changes
// (the body retains the scroll position from the prior route). Without this,
// navigating from a long landing page to /refund-policy lands the user mid-document.
//
// Behavior contract:
//   - Scroll happens AFTER the route's first paint (useEffect timing).
//   - Uses `behavior: "instant"` to avoid jarring smooth-scroll on cross-route.
//   - Does NOT scroll on hash-only changes (#enroll, #journals etc.) — those are
//     intentional in-page jumps from PageNav / footer / RefundDisclosure.
//   - Mount order matters: place inside `<LayoutInner>` so the `useLocation` hook
//     has access to the active Router context.

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        // Use `instant` to avoid smooth-scroll feel on cross-route nav.
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

export default ScrollToTop;
